import { Extension } from '@tiptap/core';

type LineHeightValue = number | null;

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        lineHeight: {
            setLineHeight: (value: number) => ReturnType;
            unsetLineHeight: () => ReturnType;
        };
    }
}

const getLineHeightValue = (value: string | null | undefined): LineHeightValue => {
    if (!value) {
        return null;
    }
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
};

export const LineHeight = Extension.create({
    name: 'lineHeight',

    addGlobalAttributes() {
        return [
            {
                types: ['paragraph', 'heading'],
                attributes: {
                    lineHeight: {
                        default: null,
                        parseHTML: (element) => getLineHeightValue(element.style.lineHeight),
                        renderHTML: (attributes) =>
                            attributes['lineHeight']
                                ? { style: `line-height: ${attributes['lineHeight']}` }
                                : {},
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setLineHeight:
                (value: number) =>
                    ({ commands }) =>
                        commands.updateAttributes('paragraph', { lineHeight: value }) ||
                        commands.updateAttributes('heading', { lineHeight: value }),
            unsetLineHeight:
                () =>
                    ({ commands }) =>
                        commands.updateAttributes('paragraph', { lineHeight: null }) ||
                        commands.updateAttributes('heading', { lineHeight: null }),
        };
    },
});
